import { resetAction } from "@/store/action-creators";
import { store } from "@/store/store";

export const redirectContinueApplicationLoader = () => {
  store.dispatch(resetAction);
  return null;
};
